<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>

<script>

import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('setupmapping.mappinglist'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('columns.grouptype'), value: "gtype", width: "200px" },
      ],

      dataItems: [],
      getId: [],
      errMsg: "",
       search: this.$route.params.search,
    };
  },
  methods: {
    loadMappingList() {
      const vm = this;
      this.$store.dispatch('get', {url: "/mapping/all"})
        .then((res) => {
          vm.dataItems = res.data.rec;
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },
    editItemHandler(item) {
      this.$router.push({ name: "mappingedit", params: { id: item.id, search: item.search } });
    },
    newRecordHandler() {
      this.$router.push({ name: "mappingnew" });
    },
  },

  mounted() {
    this.loadMappingList();
  },
};
</script>